module.exports = __webpack_public_path__ + "assets/TBisectAngleDetailed.a3e5458beeeb74a3be1ae9c85df75ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TBisectAngleDetailed.png
// module id = 575
// module chunks = 0